<template>
	<div class="cvs-applyin-mob">
		<main id="hideinlaptop" class="w-100">
			<section class="basic-card mb-3 w-100">
				<b-card v-b-toggle.collapse-1>
					<header
						class="d-flex align-items-center justify-content-between w-100 px-2 py-3"
					>
						<section
							class="d-flex align-items-center cvs-black-txt-3"
							style="font-size: 18px"
						>
							<img
								style="height: 30px; width: 30px"
								class="mr-2"
								src="@/assets/newdesign/cvs/cvs-basic-dp.svg"
								alt=""
							/>Basic Details
						</section>
						<section>
							<img src="../../assets/img/down-arrow-cvs.svg" alt="" />
						</section>
					</header>
					<body class="basic-collapse-card relativeclass">
						<b-collapse id="collapse-1">
							<b-card>
								<section
									class="d-flex align-items-center w-100 justify-content-between"
								>
									<section class="px-2 w-100 pb-4">
										<div class="d-flex w-100">
											<h2
												class="d-flex align-items-center justify-content-between w-16"
											>
												Name <span>:&nbsp;</span>
											</h2>
											<h3 class="w-75 text-break pl-2">
												{{ basicDetails.name }}
											</h3>
										</div>
										<div class="d-flex align-items-center w-100 mt-2">
											<h2
												class="d-flex align-items-center justify-content-between w-16"
											>
												Contact <span>:&nbsp;</span>
											</h2>
											<h3 class="pl-2">{{ basicDetails.contact }}</h3>
										</div>
										<div class="d-flex align-items-start w-100 mt-2">
											<h2
												class="d-flex align-items-center justify-content-between w-16"
											>
												Email <span>:&nbsp;</span>
											</h2>
											<h3 class="pl-2 text-break z-ind-2 w-84">
												{{ basicDetails.email }}
											</h3>
										</div>
									</section>
									<img
										style="height: 110px; width: 115px"
										class="cvr-image-pos"
										src="@/assets/newdesign/cvs/cvs-basic-back.svg"
										alt=""
									/>
								</section>
							</b-card>
						</b-collapse>
					</body>
				</b-card>
			</section>
		</main>
		<b-container class="cvr-main-container">
			<template>
				<main v-if="showMain" class="position-relative">
					<section
						id="hideinmobile"
						class="h-100 w-100 d-flex align-items-center justify-content-center position-relative"
					>
						<div
							class="cvr-temporary"
							:class="{ 'cvr-transition': moveToCorner }"
						></div>
					</section>
					<section
						id="hideinlaptop"
						class="w-100 d-flex justify-content-center position-relative cvr-mobile-demo-height"
					>
						<div
							class="cvr-temporary-mob"
							:class="{ 'cvr-transition-mob': moveToCorner }"
						></div>
					</section>
					<template v-if="showLoader">
						<div class="height-100dvh cvs-spinner-mob">
							<Spinner :id="'cvs'" class="h-100"></Spinner>
							<!-- <b-skeleton class="h-100 w-100"></b-skeleton>	 -->
						</div></template
					>
				</main>
				<main v-else class="cvs-h-100 w-100 d-flex mobile-flex-column">
					<section class="cvr-left-container">
						<div class="cvr-recording-div draggable-video" @touchstart.prevent>
							<div class="cvr-rec"><span class="cvr-reddot"></span>REC</div>
							<video
								style="
									transform: scaleX(-1);
									object-fit: unset;
									height: 100%;
									border-radius: 5px;
								"
								ref="camera"
								class="w-100"
								autoplay
								allowfullscreen="false"
								playsinline
								muted
							></video>
						</div>
						<div id="hideinmobile" class="cvr-basic-detail">
							<div class="d-flex align-items-center cvs-black-txt-3">
								<img
									class="mr-3"
									src="@/assets/newdesign/cvs/cvs-basic-dp.svg"
									alt=""
								/>Basic Details
							</div>
							<div class="d-flex w-100 mt-4">
								<h2>Name <span>:</span></h2>
								<h3 class="w-84 text-break">{{ basicDetails.name }}</h3>
							</div>
							<div class="d-flex align-items-center w-100 mt-2">
								<h2>Contact <span>:</span></h2>
								<h3>{{ basicDetails.contact }}</h3>
							</div>
							<div class="d-flex align-items-start w-100 mt-2">
								<h2>Email <span>:</span></h2>
								<h3 class="w-84 text-break z-ind-2">
									{{ basicDetails.email }}
								</h3>
							</div>
							<img
								class="cvr-image-pos"
								src="@/assets/newdesign/cvs/cvs-basic-back.svg"
								alt=""
							/>
						</div>
					</section>
					<section class="cvr-right-container position-relative">
						<div class="cvr-tabs">
							<div
								v-for="(ques, index) in questions"
								:key="ques.questionKey"
								class="d-flex align-items-center justify-content-between"
								:class="index != questions.length - 1 ? 'cvr-tabs-width' : ''"
							>
								<img
									v-if="ques.attempted"
									src="@/assets/newdesign/cvs/green-tab.svg"
									alt=""
									class="mob-img-height-width"
								/>
								<img
									v-else-if="ques.questionKey == selectedQues.questionKey"
									src="@/assets/newdesign/cvs/current-tab.svg"
									alt=""
									class="mob-img-height-width"
								/>
								<img
									v-else
									src="@/assets/newdesign/cvs/blue-tab.svg"
									alt=""
									class="mob-img-height-width"
								/>
								<span
									v-if="index != questions.length - 1"
									class="cvr-tab-line"
								></span>
							</div>
						</div>
						<!-- BIND card-blur CLASS HERE -->
						<div
							class="cvr-right-overflow"
							:class="okayToUseMike ? '' : 'card-blur'"
						>
							<template v-if="shimmer">
								<b-card v-for="shimmer in 5" :key="shimmer">
									<b-skeleton type="input" class="h-86px"></b-skeleton>
								</b-card>
							</template>

							<b-card
								v-for="(question, index) in questions"
								:key="question.questionKey"
							>
								<main
									class="d-flex align-items-center justify-content-between w-100 py-3 px-4 card-head-box-rqdc"
								>
									<div
										:class="
											question.questionKey != selectedQues.questionKey &&
											!question.attempted
												? 'w-75'
												: 'w-100'
										"
									>
										<h2>Question {{ index + 1 }}:</h2>

										<h3 class="cvs-black-txt-3">
											{{ question.question }}
										</h3>
									</div>

									<div
										class="pointer"
										@click="startAnswering ? null : selectQuestion(question)"
										v-if="
											question.questionKey != selectedQues.questionKey &&
											!question.attempted
										"
									>
										<img
											src="@/assets/newdesign/cvs/bluedownarrow.svg"
											alt=""
										/>
									</div>
								</main>
								<b-collapse
									:id="question.questionKey"
									:visible="
										question.questionKey == selectedQues.questionKey ||
										question.attempted
									"
								>
									<section
										v-if="
											question.attempted ||
											(startAnswering &&
												question.questionKey === selectedQues.questionKey)
										"
									>
										<div
											class="cvr-blue-back pointer"
											@click="
												startAnswering ? null : changeAnswerCollapse(index)
											"
										>
											<span class="d-flex align-items-center gap-2">
												<img src="@/assets/newdesign/cvs/urAnswer.svg" alt="" />
												{{
													question.answering && answerType == "mic"
														? "Transcribing your Answer"
														: "Your Answer"
												}}
												<span
													v-if="
														selectedQues.questionKey === question.questionKey &&
														question.answering
													"
												>
													{{ dots }}
												</span>
											</span>
											<span v-if="answerCollapse[index]"
												><img
													src="@/assets/newdesign/cvs/whiteUpArrow.svg"
													alt=""
											/></span>
											<span v-else
												><img
													src="@/assets/newdesign/cvs/whiteDownArrow.svg"
													alt=""
											/></span>
										</div>
										<b-collapse v-model="answerCollapse[index]">
											<div class="cvr-textarea card-head-box-rqdc">
												<b-form-textarea
													ref="textarea"
													:id="'text-area' + question.questionKey"
													:disabled="!question.answering"
													:value="answer[question.questionKey]"
													@input="(val) => (answer[question.questionKey] = val)"
													:placeholder="
														question.attempted && !question.answering
															? ''
															: answerType == 'mic'
															? 'Start speaking...'
															: 'Type your answer'
													"
													rows="4"
													max-rows="5"
													@paste.prevent
												></b-form-textarea>
											</div>
											<div
												class="py-3 px-4 position-relative"
												v-if="question.answering"
											>
												<div class="position-relative newredinputs">
													<b-button
														class="candash-cancelBtn-2"
														:style="doneBtnLoader ? 'opacity:0.8' : ''"
														@click="submitAnswer(index)"
														><img
															class="mr-2"
															src="@/assets/newdesign/cvs/done.svg"
															alt=""
														/>Done</b-button
													>
													<div v-if="doneBtnLoader" class="done-loader-pos-new">
														<BlueLoader />
													</div>
												</div>
											</div>
											<div class="d-flex gap-3 py-3 px-4" v-else>
												<img
													id="hideinmobile"
													@click="clearAnswer('mic', question, index)"
													src="@/assets/newdesign/cvs/mic.svg"
													alt=""
													class="pointer mob-img-height-width"
												/>
												<img
													@click="chooseAnswerType('keyboard', question, index)"
													src="@/assets/newdesign/cvs/keyboard.svg"
													alt=""
													class="pointer mob-img-height-width"
												/>
											</div>
										</b-collapse>
									</section>
									<section
										v-else-if="!startAnswering || !question.attempted"
										class="d-flex align-items-center justify-content-between p-3"
									>
										<div class="d-flex gap-3">
											<img
												id="hideinmobile"
												@click="chooseAnswerType('mic', question, index)"
												src="@/assets/newdesign/cvs/mic.svg"
												alt=""
												class="pointer mob-img-height-width"
											/>
											<img
												@click="chooseAnswerType('keyboard', question, index)"
												src="@/assets/newdesign/cvs/keyboard.svg"
												alt=""
												class="pointer mob-img-height-width"
											/>
										</div>
										<img
											id="hideinmobile"
											v-if="!isSpeaking"
											src="@/assets/newdesign/cvs/audio-wave.svg"
											alt="audio wave"
										/>
										<div
											id="hideinmobile"
											v-else-if="
												isSpeaking &&
												selectedQues.questionKey === question.questionKey
											"
										>
											<canvas ref="waveformCanvas" class="wave-canvas"></canvas>

											<div v-if="isSpeaking" class="cvs-error-text">
												Please click on mic or start typing
											</div>
										</div>
									</section>
								</b-collapse>
							</b-card>
						</div>
						<!-- AFTER BLUR THIS TOOLTIP WILL COME ON TOP -->
						<div v-if="!okayToUseMike" class="cvr-image-over-blur">
							<div class="cvr-highlighted-option">
								<img
									id="hideinmobile"
									src="@/assets/newdesign/cvs/mic.svg"
									class="set-img"
									alt=""
								/>
								<img
									src="@/assets/newdesign/cvs/keyboard.svg"
									class="set-img"
									alt=""
								/>
							</div>
							<div class="cvr-highlight-tooltip">
								<span>
									Choose the keyboard to type your answer
									<span id="hideinmobile">or the mic to transcribe it</span>.
								</span>
								<div class="d-flex justify-content-end mt-2">
									<b-button class="candash-addBtn-sm" @click="okayToUse()"
										>Okay</b-button
									>
								</div>
							</div>
						</div>
					</section>
				</main>
			</template>
		</b-container>
		<CameraAcessModal
			:showModal="cameraAcesss"
			@close="askCameraPermission()"
		/>
		<b-modal id="deleteresume_1" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="../../assets/New Profile/warning-icon.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head">Warning</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="$bvModal.hide('deleteresume_1')"
								>
									<img
										class="rotate-on-hover"
										src="../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-1 pr-3">
								This will erase your current answer. Would you still like to
								start recording again?
							</div>
						</div>
					</div>

					<div class="d-flex align-items-center justify-content-end p-3">
						<b-button
							class="candash-cancelBtn mr-4"
							@click="$bvModal.hide('deleteresume_1')"
							>Cancel</b-button
						>

						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								:disabled="removeAnswer"
								@click="
									chooseAnswerType(
										removeAnswerData.type,
										removeAnswerData.question,
										removeAnswerData.index
									)
								"
								:class="removeAnswer ? 'loader-class-delete' : ''"
								>{{ removeAnswer ? "" : "Continue" }}</b-button
							>
							<div v-if="removeAnswer" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<CvsInternet />
	</div>
</template>

<script>
import {
	getCVSQuestions,
	postCVSQuestion,
	finalSubmit,
	finishUpload,
	triggerTranscodeJob,
} from "@/utils/apiFunctions";
import { createMultipartSession, pickMimeType } from "@/utils/s3MultipartUpload";
import EventBus from "@/utils/EventBus";
import CameraAcessModal from "@/views/Dashboard/modals/CameraAcessModal.vue";
import interact from "interactjs";
import { io } from "socket.io-client";
import Loader from "../fixedcomponents/Loader.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import BlueLoader from "@/components/fixedcomponents/BlueLoader.vue";
import CvsInternet from "./CvsInternet.vue";
import { Capacitor } from "@capacitor/core";
import { Camera } from "@capacitor/camera";
import toast from "@/components/mixin/toast";
const socket = io("https://awsmultipart.hire3x.com/", {
	transports: ["websocket"],
	reconnectionDelayMax: 10000,
	timeout: 20000,
});

export default {
	name: "CvsRecording",
	components: {
		CameraAcessModal,
		Loader,
		Spinner,
		BlueLoader,
		CvsInternet,
	},
	data() {
		return {
			goBack: false,
			videoSession: null,
			currentUpload: null,
			partNumber: 1,
			chunkBuffer: [],
			chunkBufferSize: 0,
			minChunkSize: 5 * 1024 * 1024,
			elapsedTime: "00:00",
			resolveFlush: null,
			uploadData: null,
			bucket: "vccl-streams",
			bucketPath: null,
			showLoader: true,
			removeAnswer: false,
			moveToCorner: false,
			disableSubmit: true,
			doneBtnLoader: false,
			showMain: true,
			shimmer: true,
			loopvar: 5,
			openCollapseOne: false,
			startAnswering: false,
			answerCollapse: [],
			okayToUseMike: false,
			record: false,
			uuid: null,
			isSpeaking: false,
			transcript: "",
			dots: "",
			recognition: null,
			selectedQues: {
				questionKey: null,
			},
			basicDetails: {},
			answer: {},
			removeAnswerData: {},
			audiostream: [],
			recordedChunks: [], // To store audio chunks
			audioBlob: null, // To store the final audio Blob
			mediaRecorder: null, // To hold the MediaRecorder instance
			audiostream: null,
			isSubmitted: false,
			answerType: null,
			cvsvideorecord: null,
			objectId: null,
			cameraAcesss: false,
			videoStream: null,
		};
	},
	props: {
		remainingTime: {
			type: String,
			required: true, // Example: "08:45"
		},
	},
	mixins: [toast],
	created() {
		if (sessionStorage.getItem("verificationUUID")) {
			this.uuid = sessionStorage.getItem("verificationUUID");
		} else {
			this.$router.go(-1);
		}
		this.getQuestions();
		window.addEventListener("beforeunload", () => {
			localStorage.setItem("refreshed", "true");
		});
	},
	mounted() {
		this.okayToUseMike = sessionStorage.getItem("okayToUse");
		interact(".draggable-video").draggable({
			inertia: true,
			modifiers: [
				interact.modifiers.restrictRect({
					restriction: ".cvs-container",
					endOnly: true,
				}),
			],
			autoScroll: true,
			listeners: {
				move: this.dragMoveListener,
			},
		});
		EventBus.$on("submit-answer", this.submitFinalAnswer);

		const wasReloaded = sessionStorage.getItem("wasReloaded");

		if (!wasReloaded) {
			sessionStorage.setItem("wasReloaded", "true");
		} else {
			this.$emit("start-timer");
		}
		this.checkRefresh();
		this.updateElapsedTime(this.remainingTime);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
	},
	beforeDestroy() {
		if (this.videoStream) {
			this.videoStream.getTracks().forEach((track) => track.stop());
		}
		this.$emit("before-destroy");
		EventBus.$off("submit-answer");
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
	},
	methods: {
		handleBeforeUnload(event) {
			if (this.goBack) {
				const uuid = sessionStorage.getItem("verificationUUID");
				if (uuid) {
					this.$router.replace({
						name: "IdCapture",
						query: {
							uuid: uuid,
							refresh: "true",
						},
					});
				}
			}
		},
		updateElapsedTime(currentTime) {
			const startMinutes = this.convertToMinutes("10:00");
			const currentMinutes = this.convertToMinutes(currentTime);
			const diffMinutes = startMinutes - currentMinutes;

			// Avoid negative values
			const finalMinutes = Math.max(diffMinutes, 0);
			this.elapsedTime = this.convertToHHMM(finalMinutes);
		},
		convertToMinutes(timeStr) {
			const [hours, minutes] = timeStr.split(":").map(Number);
			return hours * 60 + minutes;
		},
		convertToHHMM(minutes) {
			const hrs = Math.floor(minutes / 60);
			const mins = minutes % 60;
			return `${hrs.toString().padStart(2, "0")}:${mins
				.toString()
				.padStart(2, "0")}`;
		},
		dragMoveListener(event) {
			if (window.innerWidth > 1028) return;
			let target = event.target;
			let x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
			let y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
			target.style.transform = "translate(" + x + "px, " + y + "px)";
			target.setAttribute("data-x", x);
			target.setAttribute("data-y", y);
		},
		startSpeakingEffect() {
			this.dots = "";
			let count = 0;

			this.interval = setInterval(() => {
				count = (count + 1) % 4;
				this.dots = ".".repeat(count);
			}, 500);
		},
		stopSpeakingEffect() {
			clearInterval(this.interval);
			this.dots = "";
		},
		triggerMove() {
			this.showLoader = false;
			this.moveToCorner = true;

			this.$nextTick(() => {
				// Wait for video element to be mounted
				this.askCameraPermission();
			});
		},
		okayToUse() {
			this.$emit("start-timer");
			sessionStorage.setItem("okayToUse", true);
			this.okayToUseMike = sessionStorage.getItem("okayToUse");
			this.selectQuestion(this.questions[0]);
		},
		async submitFinalAnswer() {
			this.isSubmitted = true;
			this.$emit("disableParentButton"); // Notify parent
			try {
				let fileID = localStorage.getItem("fileID");

				if (this.videoSession) {
					const sessionResult = await this.stopAndFlush();
					if (sessionResult && sessionResult.fileID) {
						fileID = sessionResult.fileID;
					}
				} else if (
					this.cvsvideorecord &&
					this.cvsvideorecord.state !== "inactive"
				) {
					this.cvsvideorecord.stop();
				}

				const fileEnv =
					process.env.VUE_APP_ENV_TYPE == 1
						? "dev"
						: process.env.VUE_APP_ENV_TYPE == 2
						? "staging"
						: "production";
				let response = await finalSubmit({
					uuid: sessionStorage.getItem("verificationUUID"),
					candidateVideo: `processed_streams/production/${this.uuid}/${this.objectId}/cvs/${this.uuid}_${this.objectId}_cvsvideorecord.mp4`,
				});
				if (response.status != 200) throw new Error(response);

				if (fileID) {
					const completeUpload = await triggerTranscodeJob(fileID, {
						convert: {
							url: "https://recruitment-api.hire3x.com/bgv/cvs/",
							method: "PUT",
							payload: {
								uuid: this.uuid,
							},
							delimiterKey: "cvsvideorecord",
						},
					});
					console.log("Complete transcode response:", completeUpload);
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.goToSubmitPage();
			}
		},
		// Stops the recorder and resolves after cvsSession.flush() completes.
		// flush() runs from onstop so the recorder's final chunk is buffered
		// before the tail is uploaded.
		stopAndFlush() {
			return new Promise((resolve, reject) => {
				if (!this.videoSession) {
					return resolve(null);
				}
				if (
					!this.cvsvideorecord ||
					this.cvsvideorecord.state === "inactive"
				) {
					return this.videoSession.flush(resolve, reject);
				}
				this.cvsvideorecord.onstop = () => {
					this.videoSession.flush(resolve, reject);
				};
				this.cvsvideorecord.stop();
			});
		},
		goToSubmitPage() {
			if (this.videoStream) {
				this.videoStream.getTracks().forEach((track) => track.stop());
				this.videoStream = null;
			}
			if (this.audiostream) {
				this.audiostream.getTracks().forEach((track) => track.stop());
				this.audiostream = null;
			}
			localStorage.removeItem("fileID");

			sessionStorage.removeItem("verificationUUID");
			this.$emit("unlock-navigation");
			this.$router.push({
				name: "CvsSubmitted",
			});
		},
		changeAnswerCollapse(index) {
			const wasOpen = this.answerCollapse[index];

			// Collapse all answer collapses
			this.answerCollapse = this.answerCollapse.map(() => false);

			if (wasOpen && this.questions[index].attempted) {
				// If current is open and attempted, open next unattempted
				for (let i = index + 1; i < this.questions.length; i++) {
					if (!this.questions[i].attempted) {
						this.selectedQues = this.questions[i]; // Trigger outer collapse
						this.$set(this.answerCollapse, i, true); // Open inner collapse
						setTimeout(() => {
							this.isSpeaking = true;
							this.startAudioCheck();
						}, 500);
						return;
					}
				}

				// If all are attempted or none found, close all and clear selection
				this.selectedQues = { questionKey: null };
			} else {
				// Just toggle current question
				this.selectedQues = this.questions[index]; // Make outer collapse visible
				this.$set(this.answerCollapse, index, true); // Open inner collapse
			}

			this.$forceUpdate(); // In case something’s missed by Vue’s reactivity
		},
		clearAnswer(type, question, index) {
			this.removeAnswerData = { type, question, index };
			this.$bvModal.show("deleteresume_1");
		},
		async chooseAnswerType(type, question, index) {
			this.updateElapsedTime(this.remainingTime);
			this.callTimeStamp(index);
			this.answerCollapse[index] = true;
			this.questions.map((_, i) => {
				this.questions[i].answering = false;
			});

			this.selectedQues = this.questions[index];
			this.questions[index].answering = true;
			this.$forceUpdate();
			this.$bvModal.hide("deleteresume_1");

			this.answerType = type;
			this.startAnswering = true;

			this.$nextTick(() => {
				if (type === "mic") {
					this.startAudioCheck().then(() => {
						this.startSpeakingEffect();

						this.initializeSpaking(question.questionKey, index);
						this.initializeRecorder();

						this.startListening(question.questionKey);
						this.startRecording();
					});
				}
			});
			this.$nextTick(() => {
				if (this.$refs.textarea[index]) {
					this.$refs.textarea[index].focus();
				}
			});
		},
		startListening(questionKey) {
			if (this.recognition) {
				this.answer[questionKey] = "";
				this.recognition.start();
			}
		},

		stopListening() {
			if (this.recognition) {
				this.recognition.stop();
			}
		},
		async submitAnswer(index) {
			try {
				this.doneBtnLoader = true;
				if (this.answerType === "mic") {
					this.recognition?.stop();
					this.stopListening();
					this.stopRecording(index);
					this.stopSpeakingEffect();
				} else {
					this.callSubmitAPI(index);
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		async callTimeStamp(index) {
			const payload = {
				uuid: this.uuid,
				questionKey: this.questions[index].questionKey,
				answerType: this.answerType === "keyboard" ? "1" : "2",
				text: this.answer[this.questions[index].questionKey],
				voice: "",
				timestamp: true,
				timestampTime: this.elapsedTime,
			};

			let form = new FormData();
			for (var key in payload) {
				form.append(key, payload[key]);
			}

			await postCVSQuestion(form);
		},
		async callSubmitAPI(index) {
			try {
				// Base payload
				const payload = {
					uuid: this.uuid,
					questionKey: this.questions[index].questionKey,
					answerType: this.answerType === "keyboard" ? "1" : "2",
					text: this.answer[this.questions[index].questionKey],
					voice: "",
				};

				if (this.answerType === "mic") {
					payload["voice"] = this.audioBlob;
				}

				let form = new FormData();
				for (var key in payload) {
					form.append(key, payload[key]);
				}

				const res = await postCVSQuestion(form);
				if (res.status === 200) {
					this.doneBtnLoader = false;
					this.startAnswering = false;
					//this.questions[index].attempted = true;
					this.isSpeaking = false;
					this.questions[index].answering = false;
					this.questions[index].attempted = true;
					this.questions[index].answerType = this.answerType;

					this.$set(this.answerCollapse, index, false); // Always collapse current

					if (index < this.questions.length - 1) {
						this.selectedQues = this.questions[index + 1];

						if (!this.questions[index + 1].attempted) {
							this.$set(this.answerCollapse, index + 1, true); // Open next if not attempted
						}

						setTimeout(() => {
							this.isSpeaking = true;
							this.startAudioCheck();
						}, 500);
					}
					if (this.questions.every((question) => question.attempted == true))
						this.$emit("all-answered");
				}
				else{
					this.errorModal("Error", "Something went wrong!");
					this.doneBtnLoader = false;
				}
				this.$forceUpdate();
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
				this.doneBtnLoader = false;
			}
			
		},
		selectQuestion(question) {
			if (this.recognition) {
				this.questions.map((_, i) => {
					this.questions[i].answering = false;
				});
				this.recognition.stop();
			}
			this.answerType = null;
			this.startAnswering = false;
			this.selectedQues = question;
			this.isSpeaking = false;
			this.answerCollapse.fill(false);
			this.$nextTick(() => {
				this.isSpeaking = true;

				setTimeout(() => {
					this.startAudioCheck(); // ensures <canvas> is rendered before accessing
				}, 1000);
			});
		},
		async getQuestions() {
			try {
				const res = await getCVSQuestions(this.uuid);
				if (res.status == 200) {
					this.basicDetails = res.data.data.data.candidateDetails;
					this.questions = res.data.data.data.questions;

					if (this.questions.every((question) => question.attempted == true)) {
						this.$emit("all-answered");
					}

					this.objectId = res.data.data.data.objectID;
					this.shimmer = false;
					this.questions.forEach((question) => {
						question.answering = false;
						this.answer[question.questionKey] = question.answer
							? question.answer.text
							: "";
					});

					this.answerCollapse = new Array(this.questions.length).fill(false);

					const nextIndex = this.questions.findIndex((q) => !q.attempted);
					if (nextIndex !== -1) {
						this.selectedQues = this.questions[nextIndex];
						this.$set(this.answerCollapse, nextIndex, true);

						this.$nextTick(() => {
							this.isSpeaking = true;
							console.log("called");
							// Delay to ensure <canvas> is rendered before initializing audio
							setTimeout(() => {
								this.startAudioCheck();
							}, 2000);
						});
					}

					this.triggerMove();
					setTimeout(() => {
						this.showMain = false;
					}, 1300);
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		initializeSpaking(questionKey, index) {
			if ("webkitSpeechRecognition" in window) {
				const SpeechRecognition =
					window.SpeechRecognition || window.webkitSpeechRecognition;
				this.recognition = new SpeechRecognition();
				this.recognition.continuous = true;
				this.recognition.interimResults = true;
				this.recognition.lang = "en-US";

				this.recognition.onresult = (event) => {
					const lastResult = event.results[event.results.length - 1];
					if (lastResult.isFinal) {
						console.log("Final transcript:", lastResult[0].transcript);
						this.answer[questionKey] += lastResult[0].transcript + " ";
						this.$forceUpdate();
					} else {
						console.log("Interim transcript:", lastResult[0].transcript);
					}
				};

				this.recognition.onerror = (event) => {
					console.error("Error occurred in recognition:", event.error);
				};

				this.recognition.onend = () => {
					this.isSpeaking = false;
					console.log("Speech recognition ended");
					if (this.questions[index].answering) {
						this.recognition.start();
					}
				};

				this.recognition.onstart = () => {
					this.isSpeaking = true;
					console.log("Speech recognition started");
					this.startAudioCheck();
				};
			} else {
				alert("Speech recognition is not supported in this browser.");
			}
		},

		async startAudioCheck() {
			try {
				this.audiostream = await navigator.mediaDevices.getUserMedia({
					audio: true,
				});
				this.handleAudioStream();
			} catch (e) {
				console.error("Error accessing microphone:", e);
			}
		},

		handleAudioStream() {
			this.audioContext = new (window.AudioContext ||
				window.webkitAudioContext)();
			const microphoneInput = this.audioContext.createMediaStreamSource(
				this.audiostream
			);
			const analyser = this.audioContext.createAnalyser();

			microphoneInput.connect(analyser);

			if (this.$refs.waveformCanvas) {
				this.canvasContext = this.$refs.waveformCanvas[0].getContext("2d");
				this.drawWaveform(analyser);
			}
		},

		async drawWaveform(analyser) {
			const bufferLength = analyser.fftSize;
			const dataArray = new Uint8Array(bufferLength);
			const canvasWidth = this.$refs.waveformCanvas[0].width;
			const canvasHeight = this.$refs.waveformCanvas[0].height;
			const sliceWidth = canvasWidth / bufferLength;

			this.canvasContext.clearRect(0, 0, canvasWidth, canvasHeight);

			const draw = () => {
				analyser.getByteTimeDomainData(dataArray);
				this.canvasContext.fillStyle = "rgb(255, 255, 255)";
				this.canvasContext.fillRect(0, 0, canvasWidth, canvasHeight);
				this.canvasContext.lineWidth = 2;
				this.canvasContext.strokeStyle = "green";
				this.canvasContext.beginPath();

				let x = 0;
				for (let i = 0; i < bufferLength; i++) {
					const y = ((dataArray[i] / 128.0) * canvasHeight) / 2;
					if (i === 0) {
						this.canvasContext.moveTo(x, y);
					} else {
						this.canvasContext.lineTo(x, y);
					}
					x += sliceWidth;
				}
				this.canvasContext.lineTo(canvasWidth, canvasHeight / 2);
				this.canvasContext.stroke();
			};

			setInterval(draw, 1000 / 60);
		},

		initializeRecorder() {
			this.recordedChunks = [];
			this.mediaRecorder = new MediaRecorder(this.audiostream);

			this.mediaRecorder.ondataavailable = (event) => {
				if (event.data.size > 0) {
					this.recordedChunks.push(event.data);
				}
			};

			this.mediaRecorder.onstop = () => {
				this.audioBlob = new Blob(this.recordedChunks, { type: "audio/webm" });
				this.updateAudioBlob();
				console.log("Recording stopped. Audio Blob created.", this.audioBlob);
			};
			this.mediaRecorder.onerror = (event) => {
				console.error("Error recording audio:", event.error);
			};
		},
		updateAudioBlob() {
			let findIndex = this.questions.findIndex((ques) => {
				return ques.questionKey === this.selectedQues.questionKey;
			});
			if (findIndex > -1) {
				this.questions[findIndex].answer.voice = this.audioBlob;
				this.callSubmitAPI(findIndex);
			}
		},
		startRecording() {
			if (this.mediaRecorder) {
				this.recordedChunks = [];
				this.mediaRecorder.start();
				console.log("Recording started...");
			} else {
				console.error("MediaRecorder is not initialized.");
			}
		},
		stopRecording() {
			if (this.mediaRecorder) {
				this.mediaRecorder.stop(); // Stop recording
			}
		},

		async askCameraPermission() {
			try {
				if (Capacitor.isNativePlatform()) {
					await Camera.requestPermissions({ permissions: ["camera"] });
				}
				this.videoStream = await navigator.mediaDevices.getUserMedia({
					video: true,
					audio: true,
				});
				this.cameraAcesss = false;

				// Wait for <video ref="camera"> to appear in DOM
				this.waitForCameraElement().then(() => {
					this.startStream(this.videoStream);
				});
			} catch (err) {
				this.cameraAcesss = true;
				this.loader = false;
				console.error("Error accessing the camera: ", err);
			}
		},
		waitForCameraElement() {
			return new Promise((resolve) => {
				const checkExist = () => {
					if (this.$refs.camera) {
						resolve();
					} else {
						setTimeout(checkExist, 100); // Retry every 100ms
					}
				};
				this.$nextTick(checkExist);
			});
		},
		async checkRefresh() {
			try {
				const isRefreshed = localStorage.getItem("refreshed") === "true";
				if (isRefreshed) {
					localStorage.removeItem("refreshed");
					await this.uploadPreviousRecord();
				}
			} catch (error) {
				console.log(error);
			}
		},
		async uploadPreviousRecord() {
			try {
				const fileID = localStorage.getItem("fileID");
				console.log("Uploading previous record with fileID:", fileID);
				if (fileID) {
					await finishUpload(fileID, { cvs: true });
					localStorage.removeItem("fileID");
				}
			} catch (error) {
				console.log(error);
			}
		},
		concatBuffers(buffers) {
			let totalLength = buffers.reduce((sum, b) => sum + b.byteLength, 0);
			let temp = new Uint8Array(totalLength);
			let offset = 0;
			for (let b of buffers) {
				temp.set(new Uint8Array(b), offset);
				offset += b.byteLength;
			}
			return temp.buffer;
		},
		isBlobCorrupted(blob) {
			return new Promise((resolve) => {
				const reader = new FileReader();

				reader.onload = () => {
					const buffer = new Uint8Array(reader.result);

					// Known file signature headers (magic numbers)
					const signatures = [
						{ magic: [0x66, 0x74, 0x79, 0x70] }, // ftyp for MP4
						{ magic: [0x52, 0x49, 0x46, 0x46] }, // RIFF for AVI
						{ magic: [0x4f, 0x67, 0x67, 0x53] }, // OggS
						{ magic: [0x1a, 0x45, 0xdf, 0xa3] }, // WebM/MKV
						{ magic: [0x00, 0x00, 0x01, 0xba] }, // MPEG
					];

					const found = signatures.some(({ magic }) => {
						return (
							buffer.findIndex((_, i) =>
								magic.every((byte, j) => buffer[i + j] === byte)
							) !== -1
						);
					});

					resolve(!found);
				};

				reader.onerror = () => {
					resolve(true); // If reading fails, assume corrupted
				};

				reader.readAsArrayBuffer(blob.slice(0, 2048)); // Read more for safety
			});
		},
		async startStream(stream) {
			try {
				this.$refs.camera.srcObject = stream;
				
				const mimeType = pickMimeType();
				const fileEnv =
					process.env.VUE_APP_ENV_TYPE == 1
						? "dev"
						: process.env.VUE_APP_ENV_TYPE == 2
						? "staging"
						: "production";
				let firstBlob = true;

				this.videoSession = createMultipartSession();
				
				const timestamp = Date.now();
				const formatExt = mimeType.includes("mp4") ? ".mp4" : ".webm";
				const fileName = `${this.uuid}_${this.objectId}_cvsvideorecord${formatExt}`;
				const pathPrefix = `processed_streams/${fileEnv}/${this.uuid}/${this.objectId}/cvs/`;
				this.bucketPath = `${pathPrefix}${fileName}`;

				await this.videoSession.initiate(fileName, this.bucketPath, pathPrefix, mimeType);
				
				// Save file ID in localStorage for recovery/cleanup
				localStorage.setItem("fileID", this.videoSession.getFileID() || "");

				this.cvsvideorecord = new MediaRecorder(stream, { mimeType });

				this.cvsvideorecord.ondataavailable = async (event) => {
					if (!event.data || event.data.size === 0) return;

					if (firstBlob) {
						const isCorrupted = await this.isBlobCorrupted(event.data);
						if (isCorrupted) {
							console.log("Blob is corrupted");
							location.reload();
							return;
						}
					}
					firstBlob = false;

					this.videoSession.feedBlob(event.data);
				};

				this.cvsvideorecord.start(5000);
				console.log("CVS recording started with slice interval of 5s");
			} catch (error) {
				console.error("Error accessing the camera: ", error);
			}
		},
	},
};
</script>

<style scoped>
.cvr-main-container {
	height: 100%;
	width: 100%;
	max-width: 1300px;
	padding: 0;
	padding-top: 40px;
	padding-bottom: 30px;
}

.cvr-temporary {
	height: 400px;
	width: 700px;
	background-color: black;
	transition: all 1s ease;
	position: absolute;
	top: 312px;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 4px;
	overflow: hidden;
}

.cvr-transition {
	height: 315px;
	width: 561px;
	top: 0;
	left: 20px;
	transform: translate(0, 0);
}

.cvr-left-container {
	height: 100%;
	overflow-y: auto;
	padding-left: 20px;
	overflow-x: hidden;
	width: 583px;
}
.cvr-left-container::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.cvr-recording-div {
	height: 315px;
	width: 561px;
	background-color: black;
	border-radius: 4px;
	overflow: hidden;
	position: relative;
}

.cvr-basic-detail {
	background: linear-gradient(245.47deg, #e9e5fd 8.01%, #d4cafd 100%);
	position: relative;
	padding: 20px;
	height: 315px;
	margin-top: 20px;
	border-radius: 10px;
	overflow: hidden;
}

.cvr-basic-detail h2 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: #666666;
	width: 14%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: fit-content;
}

.cvr-basic-detail h3 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--cv-darkgrey);
	padding-left: 8px;
	word-break: break-all;
	width: 75%;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

.cvr-right-container {
	flex: 1;
	margin-left: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	opacity: 0; /* Initially hidden */
	animation: fadeIn 0.6s ease-in-out forwards;
	animation-delay: 0.2s; /* Optional delay before the transition starts */
}

.cvr-right-overflow {
	height: calc(100vh - 200px);
	overflow-y: auto;
	width: 100%;
	margin-top: 20px;
	padding: 0px 20px 0px 20px;
}
.cvr-right-overflow::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.cvr-tabs {
	width: 90%;
	background: #4f8fd214;
	border-radius: 12px;
	display: flex;
	align-items: center;
	padding: 10px 20px;
	gap: 10px;
}

.cvr-tab-line {
	background-color: #bdcdda;
	border-radius: 10px;
	width: calc(100% - 40px);
	height: 5px;
	display: flex;
}

.cvr-tabs-width {
	width: calc((100% - 29px) / 4);
}

.cvr-right-overflow .card {
	background-color: #ffffff;
	width: 100%;
	box-shadow: 10px 10px 28px 0px #0000001a;
	border-radius: 18px;
	border: none;
	overflow: hidden;
	margin-bottom: 10px;
}

.cvr-right-overflow .card-body {
	padding: 0;
}

.cvr-right-overflow h2 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: #8c8c8c;
}

.cvr-highlighted-option {
	display: flex;
	gap: 10px;
	padding: 5px 10px;
	background-color: #ffffff;
	box-shadow: 0px 4px 4px 0px #00000040;
	border-radius: 25px;
	position: absolute;
	left: 40px;
	top: 190px;
}

.cvr-blue-back {
	background-color: #f4f6fb;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: var(--cv-darkgrey);
	padding: 15px 20px;
}

.cvr-textarea .form-control {
	border: none;
	overflow-y: auto !important;
}

.cvr-textarea .form-control:focus {
	box-shadow: none;
}

.cvr-highlight-tooltip {
	position: absolute;
	background-color: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 4px 4px 0px #00000040;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-LM);
	color: var(--cv-darkgrey);
	top: 248px;
	left: 40px;
	width: 330px;
	padding: 15px 20px;
}

.cvr-reddot {
	height: 9px;
	width: 9px;
	border-radius: 50%;
	background-color: #f44336;
}

.cvr-rec {
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: var(--cv-black);
	background-color: #ffffff;
	border-radius: 4px;
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 3px 5px;
	position: absolute;
	left: 15px;
	top: 15px;
	z-index: 1;
}
.wave-canvas {
	width: 250px;
	height: 15px;
}

.cvs-error-text {
	color: red;
	font-weight: var(--weight-LM);
	font-size: 12px;
}
.cvs-applyin-mob {
	width: 100%;
}
.cvs-h-100 {
	height: calc(100vh - 162px);
}
.done-loader-pos-new {
	position: absolute;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 0px;
}

/* mobile screen design starts here */
@media only screen and (max-width: 1028px) {
	.cvs-spinner-mob {
		position: absolute;
		top: 0px;
		width: 100%;
	}
	.cvs-h-100 {
		height: 100%;
	}
	.wave-canvas {
		width: 150px;
		height: 15px;
	}
	.cvs-error-text {
		font-size: 10px;
	}
	.cvs-applyin-mob {
		width: 100%;
	}
	.mobile-flex-column {
		flex-direction: column;
		width: 100%;
	}

	.cvr-main-container {
		margin: 0;
		padding: 0;
		width: 100%;
	}

	.cvr-left-container {
		width: 100%;
	}

	.cvr-right-container {
		position: absolute !important;
		width: 100%;
		margin-left: 0;
		overflow-x: hidden;
		background-image: url("../../assets/newdesign/cvs/background.png");
		background-repeat: no-repeat;
		background-size: cover;
	}

	.cvr-right-overflow {
		padding: 0;
		width: 90%;
	}

	.cvr-tabs {
		margin-top: 10px;
	}

	.cvr-recording-div {
		position: fixed;
		bottom: 36px;
		z-index: 1038;
		height: 130px;
		width: 250px;
		right: 13px;
	}

	.cvr-highlighted-option {
		left: 30px;
		top: 120px;
	}

	.cvr-highlight-tooltip {
		top: 165px;
		left: 30px;
		width: 270px;
	}

	.mob-img-height-width {
		height: 25px;
		width: 25px;
	}

	.set-img {
		height: 30px;
		width: 30px;
	}

	.cvr-temporary-mob {
		height: 400px;
		width: 100%;
		background-color: black;
		transition: all 1.2s ease;
		position: absolute;
		transform: translate(0, 0);
		border-radius: 4px;
		overflow: hidden;
	}

	.cvr-transition-mob {
		height: 130px;
		width: 250px;
		bottom: 36px;
		right: 0px;
		transform: translate(0, 0);
	}
	.cvr-mobile-demo-height {
		height: calc(100vh - 150px);
	}
	.done-loader-pos-new {
		left: -28%;
	}
}
</style>
